import React from 'react';

import { getChainPrivateApi } from '#/api/apiCoreSdk';
import DownloadCsvButton from '#/components/wallet/DownloadCsvButton';

export default function DownloadTradesCSV({ disabled }: { disabled: boolean }) {
  // Test with wallet: '0x0000000484f2217f1a64eb6d24b5cee446faeae5';
  return (
    <DownloadCsvButton
      getDownloadUrl={wallet =>
        getChainPrivateApi().getInternalFillHistoryCsvLink({ wallet })
      }
      disabled={disabled}
      title="Trades"
    />
  );
}
